import axios from "axios";
import { acquisitionPayload } from "./acquisition";

const TOKEN_API_KEY = process.env.REACT_APP_TOKEN_API_KEY;
const TOKEN_API_SECRET = process.env.REACT_APP_TOKEN_API_SECRET;
const API_URL = process.env.REACT_APP_API_URL;

const Services = {
  MeMeetSetRecording(token, { roomID, on }) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-set-meeting-recording`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { roomID, on } });
  },
  MeMeetMeetingSummarize(token, { roomID }) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-meeting-summarize`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { roomID } });
  },
  MeMeetGetMeetingSummary(token, { roomID }) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-get-meeting-summary`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { roomID } });
  },
  MeMeetListSummaries(token, { from, to } = {}) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-list-summaries`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { from, to } });
  },
  /* ---------- Toplanti planlama (2026-09-14) ---------- */
  MeMeetScheduleMeeting(token, payload) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-schedule-meeting`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: payload,
    });
  },
  MeMeetUpcomingMeetings(token, { days = 14, limit = 20 } = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-upcoming-meetings`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { days, limit },
    });
  },
  MeMeetRespondToMeeting(token, { roomID, response }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-respond-to-meeting`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { roomID, response },
    });
  },
  MeMeetCancelMeeting(token, roomID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-cancel-meeting`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { roomID },
    });
  },
  MeMeetRecentRooms(token, limit = 10) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-recent-rooms`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { limit } });
  },
  MeMeetGetSummaryById(token, { id }) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-get-summary-by-id`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { id } });
  },
  MeMeetGetRecordingState(token, { roomID }) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-get-recording-state`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { roomID } });
  },
  MeMeetDeleteSummary(token, { id }) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-delete-summary`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { id } });
  },
  MeMeetStartVideoRecording(token, { roomID }) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-start-video-recording`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { roomID } });
  },
  MeMeetStopVideoRecording(token, { roomID }) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-stop-video-recording`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { roomID } });
  },
  MeMeetVideoRecordingState(token, { roomID }) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-video-recording-state`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { roomID } });
  },
  MeMeetListVideoRecordings(token) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-list-video-recordings`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: {} });
  },
  MeMeetGetVideoRecordingLink(token, { id }) {
    return axios({ method: "post", url: `${API_URL}flow/memeet-get-video-recording-link`, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, data: { id } });
  },
  GetToken() {
    return axios({
      method: "post",
      url: `${API_URL}get-token`,
      data: {
        key: TOKEN_API_KEY,
        secret: TOKEN_API_SECRET,
      },
    });
  },

  UserRegister(token, name, lastname, email, password) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-register`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        name,
        lastname,
        email,
        password,
        source:"memeet",
        acquisition: acquisitionPayload("memeet"),
      },
    });
  },

  // Google ile giris: @react-oauth/google'dan alinan ID token backend'e gider;
  // backend tokeninfo ile dogrular, user_oauth_identities uzerinden eslestirir
  // (e-posta eslesmezse kullaniciyi olusturur) ve normal login ile AYNI
  // token+user zarfini dondurur. `token` uygulama (anonim) bearer'idir.
  // registration_source "memeet": e-posta ile kayit (memeet-register) da bunu yazar.
  LoginWithGoogle(token, idToken, registrationSource = "memeet") {
    return axios({
      method: "post",
      url: `${API_URL}flow/login-with-google-id-token`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { id_token: idToken, registration_source: registrationSource, acquisition: acquisitionPayload(registrationSource) },
    });
  },

  UserLogin(token, credential, password) {
    return axios({
      method: "post",
      url: `${API_URL}flow/user-login`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        credential,
        password,
      },
    });
  },

  CreatePageView(token, page) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-page-view`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { page },
    });
  },

  GetUserWorkspaces(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-my-workspaces`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  GetUserAuthorizations(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-users-authorizations-by-user-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID: userID,
      },
    });
  },

  // Checklist Services
  GetChecklistsByWorkspaceID(token, workspaceID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/checklist-get`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        workspaceID,
      },
    });
  },

  CreateChecklist(token, title, step, workspaceID, description) {
    return axios({
      method: "post",
      url: `${API_URL}flow/checklist-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title,
        description,
        isQueueRestricted: step,
        workspaceID,
      },
    });
  },

  UpdateChecklist(token, title, elements, description, checklistID, isQueueRestricted) {
    return axios({
      method: "post",
      url: `${API_URL}flow/checklist-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        checklistID,
        elements,
        title,
        description,
        isQueueRestricted,
      },
    });
  },

  // Notes Services
  GetMyNotes(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-my-notes`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  CreateNote(token, folderId) {
    const payload = folderId ? { folderId } : {};
    return axios({
      method: "post",
      url: `${API_URL}flow/note-write`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });
  },

  NoteUpdate(token, noteId, content) {
    return axios({
      method: "post",
      url: `${API_URL}flow/note-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: noteId,
        updateData: {
          content,
        },
      },
    });
  },

  TouchToNote(token, noteId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/touch-to-note`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        noteId: noteId,
      },
    });
  },

  NoteTitleUpdate(token, noteId, title) {
    return axios({
      method: "post",
      url: `${API_URL}flow/note-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        id: noteId,
        updateData: {
          title,
        },
      },
    });
  },

  // Social Hive Services
  SocialHiveGetDMRoomList(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-get-dm-room-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  SocialHiveCreateDM(token, targetUserId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/social-hive-create-dm`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        targetUserId,
      },
    });
  },

  // Link Preview
  GetLinkPreview(token, url) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-link-preview`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        url,
      },
    });
  },

  // Subscription
  GetUserSubscriptionInfos(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-user-subscription-infos`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  // MeMeet Room
  CreateRoom(token, { domain, roomID, isPrivate, passCode, isTemporary, title, startDateTime, endDateTime, timezone }) {
    const payload = {
      domain: "memeet.lodos.io",
      roomID,
      isPrivate,
      isTemporary,
    };

    if (typeof passCode === "string") {
      payload.passCode = passCode;
    }
    if (typeof title === "string" && title.trim()) {
      payload.title = title.trim();
    }
    if (typeof startDateTime === "string" && startDateTime.trim()) {
      payload.startDateTime = startDateTime.trim();
    }
    if (typeof endDateTime === "string" && endDateTime.trim()) {
      payload.endDateTime = endDateTime.trim();
    }
    if (typeof timezone === "string" && timezone.trim()) {
      payload.timezone = timezone.trim();
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-create-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });
  },

  GetRoom(token, { roomID }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-get-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
      },
    });
  },

  MeMeetRoomParticipants(token, { roomID }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-room-participants`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
      },
    });
  },

  MeMeetRequestJoin(token, { roomID, name }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-request-join`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
        name,
      },
    });
  },

  MeMeetListJoinRequests(token, { roomID }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-list-join-requests`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
      },
    });
  },

  MeMeetApproveJoin(token, { roomID, userID, approve }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-approve-join`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
        userID,
        approve,
      },
    });
  },

  MeMeetMuteParticipant(token, { roomID, identity, muted }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-mute-participant`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
        identity,
        muted,
      },
    });
  },

  CheckPassCode(token, { roomID, passCode }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-check-pass-code`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
        passCode,
      },
    });
  },

  GetCollaborators(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-collaborators`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  MeMeetInviteUser(token, { roomID, userID, email, nameLastname, notify}) {
    const normalizedRoomID = String(roomID || "").trim();
    const normalizedUserID = String(userID || "").trim();
    const normalizedEmail = String(email || "").trim();
    const normalizedNameLastname = String(nameLastname || "").trim();

    if (!normalizedRoomID) {
      throw new Error("roomID is required");
    }

    const hasUserID = Boolean(normalizedUserID);
    const hasEmail = Boolean(normalizedEmail);

    if (hasUserID === hasEmail) {
      throw new Error("Provide either userID or email");
    }

    const payload = { roomID: normalizedRoomID };

    if (hasUserID) {
      payload.userID = normalizedUserID;
    }

    if (hasEmail) {
      if (!normalizedNameLastname) {
        throw new Error("nameLastname is required when email is provided");
      }
      payload.email = normalizedEmail;
      payload.nameLastname = normalizedNameLastname;
    }

    // Bildirim kanallari — kullanici secimi. Dizi degilse hic gonderme
    // (backend varsayilani "hicbir sey gonderme"dir).
    if (Array.isArray(notify)) payload.notify = notify;

    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-invite-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });
  },

  MeMeetIsInvitedUser(token, { roomID, userID, email }) {
    const normalizedRoomID = String(roomID || "").trim();
    const normalizedUserID = String(userID || "").trim();
    const normalizedEmail = String(email || "").trim();

    if (!normalizedRoomID) {
      throw new Error("roomID is required");
    }

    const hasUserID = Boolean(normalizedUserID);
    const hasEmail = Boolean(normalizedEmail);

    if (hasUserID === hasEmail) {
      throw new Error("Provide either userID or email");
    }

    const payload = { roomID: normalizedRoomID };
    if (hasUserID) payload.userID = normalizedUserID;
    if (hasEmail) payload.email = normalizedEmail;

    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-is-invited-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });
  },

  MeMeetRemoveInvitation(token, { invitationCode }) {
    const normalizedInvitationCode = String(invitationCode || "").trim();
    if (!normalizedInvitationCode) {
      throw new Error("invitationCode is required");
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-remove-invitation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        invitationCode: normalizedInvitationCode,
      },
    });
  },

  MeMeetGetInvitations(token, { roomID }) {
    const normalizedRoomID = String(roomID || "").trim();
    if (!normalizedRoomID) {
      throw new Error("roomID is required");
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-get-invitations`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID: normalizedRoomID,
      },
    });
  },

  MeMeetAcceptInvitation(token, { invitationCode }) {
    const normalizedInvitationCode = String(invitationCode || "").trim();
    if (!normalizedInvitationCode) {
      throw new Error("invitationCode is required");
    }

    const headers = {
      "Content-Type": "application/json",
    };
    if (typeof token === "string" && token.trim()) {
      headers.Authorization = `Bearer ${token}`;
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-accept-invitation`,
      headers,
      data: {
        invitationCode: normalizedInvitationCode,
      },
    });
  },

  // Token System
  GetTokenBalance(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-token-balance`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  CheckModuleCost(token, moduleKey, operationKey = "default") {
    return axios({
      method: "post",
      url: `${API_URL}flow/check-module-cost`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { moduleKey, operationKey },
    });
  },

  DeductTokens(token, moduleKey, operationKey = "default") {
    return axios({
      method: "post",
      url: `${API_URL}flow/deduct-tokens`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { moduleKey, operationKey },
    });
  },

  GetMonthlyUsageSummary(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-monthly-usage-summary`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },

  MeMeetUserJoin(token, { roomCreatorID, roomID, joiningUserID }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-user-join`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { roomCreatorID, roomID, joiningUserID },
    });
  },

  MeMeetRejectInvitation(token, { invitationCode }) {
    const normalizedInvitationCode = String(invitationCode || "").trim();
    if (!normalizedInvitationCode) {
      throw new Error("invitationCode is required");
    }

    const headers = {
      "Content-Type": "application/json",
    };
    if (typeof token === "string" && token.trim()) {
      headers.Authorization = `Bearer ${token}`;
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/memeet-reject-invitation`,
      headers,
      data: {
        invitationCode: normalizedInvitationCode,
      },
    });
  },
};

export default Services;
